import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { SessionConflictService } from 'src/app/services/session-conflict.service';

@Component({
  selector: 'app-session-conflict-modal',
  template: `
    <div *ngIf="show" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div class="bg-white rounded-lg p-6 w-[440px] max-w-[calc(100%-2rem)] shadow-lg text-center">
        <!-- Ícone roxo -->
        <div class="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-west-purple-50">
          <svg class="h-6 w-6 text-westetics-purple-800" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
          </svg>
        </div>

        <h2 class="font-bold text-lg text-westetics-neutral-950 mb-2">Sessão encerrada</h2>
        <p class="text-sm text-westetics-neutral-800 mb-6">{{ message }}</p>

        <button
          (click)="onConfirm()"
          class="w-full px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600 transition-colors">
          Ok
        </button>
      </div>
    </div>
  `,
  styles: []
})
export class SessionConflictModalComponent implements OnInit, OnDestroy {
  show = false;
  message = '';
  private subs: Subscription[] = [];

  constructor(
    private sessionConflictService: SessionConflictService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.subs.push(
      this.sessionConflictService.showModal$.subscribe(val => this.show = val),
      this.sessionConflictService.conflictMessage$.subscribe(val => this.message = val)
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  onConfirm(): void {
    this.sessionConflictService.dismiss();
    this.authService.clear();
    this.router.navigate(['/login']);
  }
}
